const recentlyCalled = {
  subdomain: false,
  internalServerError: false,
  offline: false,
};

export function debouncedAlerts(
  message: string,
  key: keyof typeof recentlyCalled,
  timeout = 3000,
) {
  if (recentlyCalled[key]) {
    console.log(`Skipping duplicate alert: ${key}`);
    return;
  }
  recentlyCalled[key] = true;
  alert(message);
  setTimeout(() => {
    recentlyCalled[key] = false;
  }, timeout);
}

export function debouncedSubdomainAlert() {
  debouncedAlerts(
    'Subdomain blocked preventing access and display of data. Please contact your IT department to ensure subdomain *.manhole-metrics.com is whitelisted.',
    'subdomain',
  );
}

export function debouncedInternalServerErrorAlert() {
  debouncedAlerts(
    'Internal Server Error. Please try again later.',
    'internalServerError',
  );
}

export function debouncedOfflineAlert() {
  debouncedAlerts(
    'You are currently offline. Please check your internet connection and try again.',
    'offline',
  );
}
